import { clone } from '@/utils/helpers';

export const mergeDynamicTags = (...tagsSet: string[][]): string[] => {
	let dynamicTags: string[] = [];
	tagsSet.forEach(tags => {
		dynamicTags = dynamicTags.concat(clone(tags));
	});
	return dynamicTags.filter((tag, tagIdx) => {
		return dynamicTags.indexOf(tag) === tagIdx; // This will prevent duplicated tags
	});
};



/**
 * Find all links in the given template (supports both HTML and Beefree JSON formats)
 * @param {string} template - Template content (HTML string or Beefree JSON string)
 * @returns {string[]} All links in the template
 */

export function findAllLinksInBeefreeTemplate(template: string) {
	const urls: string[] = [];

	if (!template || typeof template !== 'string') {
		return urls;
	}

	try {
		// Try to parse as JSON first (Beefree format)
		const jsonObj = JSON.parse(template);
		
		function traverse(obj: any) {
			for (const key in obj) {
				if (typeof obj[key] === 'object') {
					traverse(obj[key]);
				} else if (typeof obj[key] === 'string') {
					const anchorRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g;
					let match;
					while ((match = anchorRegex.exec(obj[key])) !== null) {
						urls.push(match[1]);
					}
				}

				if (key === 'button' && obj[key] && typeof obj[key] === 'object' && obj[key].href) {
					urls.push(obj[key].href);
				}
			}
		}

		traverse(jsonObj);
	} catch (error) {
		// If JSON parsing fails, treat it as HTML content
		try {
			const anchorRegex = /<a\s+(?:[^>]*?\s+)?href=["']([^"']*?)["']/gi;
			let match;
			while ((match = anchorRegex.exec(template)) !== null) {
				urls.push(match[1]);
			}
		} catch (htmlError) {
			console.warn('Failed to process template for link extraction:', htmlError);
		}
	}
	
	return urls;
}
